import update from 'immutability-helper'
/**
 * 修改 video box config
 */

export function updateVideoBox(node: any, action) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { type, id, url } = action
  return update(node, {
    config: {
      videoSrc: {
        $set: url,
      },
    },
  })
}
